import { useEffect } from 'react';
import { frameStore } from 'apps/components/Frame/appManager';
import { ViewTypeEnum } from 'types';

export const useViewType = (defaultType: ViewTypeEnum) => {
  const lastType = localStorage.getItem('projects-view-type');
  useEffect(() => {
    frameStore.SetViewType(frameStore.viewType || lastType || defaultType);
    localStorage.setItem('projects-view-type', frameStore.viewType);
  }, [frameStore.viewType, defaultType]);
};
